import { AdapterRole } from '@cbsinteractive/avia-js';
import { clid3 } from '@cbsinteractive/avia-js-clid3';
import { ID3 } from 'library/ts/enums/metadata/ID3';
import { ITagAbstractClassArgument } from 'tag/ts/tag/interfaces/arguments/ITagAbstractClassArgument';
import { IAviaPlugin } from 'tag/ts/tag/player/adapters/avia/interfaces/IAviaPlugin';
import { AviaPlugin } from 'tag/ts/tag/player/adapters/avia/plugins/AviaPlugin';

/**
 * @copyright © Paramount Streaming
 * @author  Daniel Silva
 * @description Avia CLID3 ("Clyde") plugin integration for ID3-driven ad + squeezeback tracking
 */
export class Clid3Plugin extends AviaPlugin implements IAviaPlugin {
	package = clid3;
	namespaceKey = 'plugin_clid3';

	constructor( argument: ITagAbstractClassArgument ) {
		super(
			{
				...argument,
				name: 'Clid3Plugin'
			}
		);
	}

	/**
	 * @description Determines if CLID3 plugin should be used.
	 * @returns {boolean}
	 */
	shouldBeUsed(): boolean {
		const isLinearAdTrackable = this.tag?.model?.contentUtilities?.isLinearAdTrackable?.() === true;
		if ( !isLinearAdTrackable ) {
			return false;
		}

		const template = this.tag?.model?.adUtilities?.getLinearAdTrackUrl?.();
		return this.utils.Type.isString( template ) && !this.utils.Type.isEmpty( template );
	}

	/**
	 * @description Provides CLID3 plugin configuration parameters for Avia player.
	 * @returns {Record<string, any>}
	 */
	getFactoryParams() {
		const adsRequestTemplate = this.tag?.model?.adUtilities?.getLinearAdTrackUrl?.();
		const id3OwnerId = ID3.LINEAR_AD_TRACKING;
		const isLiveDAIStream = this.tag?.model?.contentUtilities?.isLiveDAIStream?.( this.tag?.model?.apiMetadata ) === true;
		const role = isLiveDAIStream ? AdapterRole.SQUEEZEBACK : AdapterRole.AD;

		this?.logger?.log(
			'getFactoryParams',
			'CLID3 plugin configured:',
			'role:',
			role,
			'id3OwnerId:',
			id3OwnerId,
			'has adsRequestTemplate:',
			this.utils.Type.isString( adsRequestTemplate ) && !this.utils.Type.isEmpty( adsRequestTemplate )
		);

		return {
			...super.getFactoryParams(),
			adsRequestTemplate,
			id3OwnerId,
			role
		};
	}
}